// Live websocket catchup interleaves with heartbeats, status frames, and fresh
// agent output, so keep individual pages modest until bulk history uses a
// separate lane consistently. Larger pages improve throughput, but they also
// create visibly burstier browser apply work and longer uninterrupted DO slices.
export const NEW_SYNC_WEBSOCKET_PAGE_ROW_CAP = 100;
// Quarter-megabyte websocket pages are large enough to amortize framing
// overhead while staying well below the multi-megabyte range that tends to
// create spiky browser parse/apply stalls for a single live frame burst.
export const NEW_SYNC_WEBSOCKET_PAGE_BYTE_CAP = 256 * 1024;

// Read-only HTTP history catchup does not compete with live socket flushes, so
// it can use meaningfully larger pages. Four hundred rows is a 4x step up from
// websocket history without making a single page unreasonably large when events
// are compact but numerous.
export const NEW_SYNC_HTTP_BULK_PAGE_ROW_CAP = 400;
// One-megabyte HTTP history pages materially improve bulk throughput for long
// threads while staying below sizes that commonly turn one page into a browser
// parse or IndexedDB append cliff.
export const NEW_SYNC_HTTP_BULK_PAGE_BYTE_CAP = 1024 * 1024;

// Clamp caller-provided HTTP row caps so a buggy or stale client cannot request
// pages large enough to monopolize the DO read path or blow up browser decode
// cost. Eight hundred rows is intentionally only 2x the current bulk default.
export const NEW_SYNC_HTTP_BULK_PAGE_ROW_CAP_MAX = 800;
// Keep the hard byte ceiling comfortably below the sizes that would make a
// single bulk page feel like an all-or-nothing blob transfer in the browser.
// Two megabytes is a safety ceiling, not a new steady-state target.
export const NEW_SYNC_HTTP_BULK_PAGE_BYTE_CAP_MAX = 2 * 1024 * 1024;
